import FoodMenuIcon from '@material-ui/icons/ViewList';

import PurchaseCancelRequestAuthorizeList from './PurchaseCancelRequestAuthorizeList';
import PurchaseCancelRequestAuthorizeShow from "./PurchaseCancelRequestAuthorizeShow";

export default {
    list: PurchaseCancelRequestAuthorizeList,
    show: PurchaseCancelRequestAuthorizeShow,
    icon: FoodMenuIcon,
};
